
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

console.log("Ambiente:", import.meta.env.MODE);
console.log("Base URL:", import.meta.env.BASE_URL);
console.log("Public URL:", import.meta.env.PUBLIC_URL || "não definido");
console.log("Iniciando aplicação - script main.tsx executando");

const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("Elemento root não encontrado");
} else {
  console.log("Elemento root encontrado, renderizando App");
  createRoot(rootElement).render(<App />);
}

// Adicionar um log depois da renderização
console.log("Renderização do App iniciada");
